// import { setDefaultOptions } from "esri-loader";
import { memo, useContext, useEffect, useRef } from "react";
import { StyledLoader } from "./App-styled";

import { ConfigContext } from "../../utils/ConfigContext";
import { useSnackbar } from "../SnackBar";

import { User } from "oidc-client-ts";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

import "shepherd.js/dist/css/shepherd.css";
import { register } from "swiper/element/bundle";

import { setAuthUser } from "../../redux/action/userReducer-action";
import Analytics from "./Analytics";
import DesktopApp from "./DesktopApp";
import MobileApp from "./MobileApp";

register();

export const snackOptions = {
  position: "top-center",
  style: {
    backgroundColor: "#FFFFFF",
    color: "#393738",
  },
  closeStyle: {
    color: "#393738",
  },
};

export const MOBILE_SCREENS = Object.freeze({
  MAP: "Map",
  TABLE: "FeatureTable",
  INSIGHTS: "Insights",
});

/**
 * 4.23 gives errors for FeatureTable.filterGeometry accessors (although it works correctly in the end)
 * 4.26: unable to add features with the editor widget
 */
// setDefaultOptions({ css: true, version: "4.30" });

const App = () => {
  const { config, activeLanguage, setActiveLanguage } =
    useContext(ConfigContext);
  const [openSnackbar] = useSnackbar(snackOptions);

  const mobileReducer = useSelector((store) => store.mobileReducer);
  const view = useSelector((store) => store.mapViewReducer.view);

  const auth = useAuth();
  const dispatch = useDispatch();
  const isRedirecting = useRef(false);

  useEffect(() => {
    if (!view) return;
    if (!config) return;
    const user = getUser(auth);

    if (
      config.auth === "wfp" &&
      !user &&
      !auth.isLoading &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !isRedirecting.current
    ) {
      localStorage.setItem("authType", config.auth);
      isRedirecting.current = true;
      auth.signinRedirect({
        state: {
          url: window.location.href,
          search: window.location.search,
        },
      });
    }
  }, [config.auth, auth, view]);

  useEffect(() => {
    if (auth.isAuthenticated && !auth?.user?.profile?.given_name) {
      auth
        .removeUser()
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    dispatch(setAuthUser(auth));
  }, [auth.isAuthenticated]);

  if (config.auth === "wfp" && auth.isLoading) {
    return (
      <StyledLoader
        text="This is a secured content. Redirecting user to the authentication page"
        id="app-loader"
      >
        <calcite-loader></calcite-loader>
      </StyledLoader>
    );
  }

  //ESRI authentication can cause the auth object to give error. Check if the url is set, in this case the authorization was triggered by us
  if (auth.error && auth.user?.state?.url)
    return <div>Oops... {auth.error.message}</div>;

  const AppComponent = mobileReducer.isMobileApp ? (
    <MobileApp
      config={config}
      view={view}
      openSnackbar={openSnackbar}
      activeLanguage={activeLanguage}
      setActiveLanguage={setActiveLanguage}
    />
  ) : (
    <DesktopApp
      config={config}
      view={view}
      openSnackbar={openSnackbar}
      activeLanguage={activeLanguage}
      setActiveLanguage={setActiveLanguage}
    />
  );

  return (
    <>
      <Analytics />
      {AppComponent}
    </>
  );
};

export default memo(App);

const getUser = (auth) => {
  const oidcStorage = sessionStorage.getItem(
    `oidc.user:${auth.settings.authority}:${auth.settings.client_id}`
  );
  if (!oidcStorage) return null;

  return User.fromStorageString(oidcStorage);
};
